import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_food-grubhub/restaurant/$restaurantId/menuItem/$menuItemId/',
)({})
